export const locale = {
    lang: 'en',
    data: {
        NAV: {
            CONFIGURACOES: 'Configurações'
        }
    }
};
